module.exports = __webpack_public_path__ + "static/analytics-desktop@2-bd307f1d9b2794e0d80285aa92f5430e.png";